import { Component, ElementRef, OnInit } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { NotificationService } from "src/app/Service/notification.service";
import { OtherService } from "src/app/Service/other.service";
import { registerables } from 'chart.js';
import Chart from 'chart.js/auto';
import axios from "src/app/Service/axios";
import { Location } from '@angular/common';
import Map from 'ol/Map';
import View from 'ol/View';
import * as olProj from 'ol/proj';
import VectorLayer from 'ol/layer/Vector';
import {
  DragRotateAndZoom,
  defaults as defaultInteractions,
} from 'ol/interaction';
import Feature from 'ol/Feature';
import { Tile as TileLayer } from 'ol/layer';
import OSM from 'ol/source/OSM';

import { Point } from "ol/geom";
import { BingMaps, Cluster, Vector, XYZ } from "ol/source";

import AnimatedCluster from "ol-ext/layer/AnimatedCluster";
import SelectCluster from "ol-ext/interaction/SelectCluster";
import { Tile } from "ol/layer";
import { MapService } from "src/app/Service/map.service";
import { DeviceDetectorService } from "ngx-device-detector";
import { Circle, Fill, Stroke, Style, Text } from "ol/style";
import "ol/ol.css";
import * as XLSX from 'xlsx';
import zoomPlugin from 'chartjs-plugin-zoom';
import { getRelativePosition } from 'chart.js/helpers';
import { FormBuilder, FormControl, FormGroup } from "@angular/forms";
import momentJalaali from "moment-jalaali";
import { DataService } from "src/app/Service/data.service";
import { GurdServiceService } from "src/app/Service/gurd-service.service";
import VectorSource from "ol/source/Vector";
declare let $: any;

@Component({

  selector: 'app-dashboardpro',

  templateUrl: './dashboardpro.component.html',

  styleUrls: ['./dashboardpro.component.css']

})

export class DashboardproComponent implements OnInit {

  constructor(private notifyService: NotificationService,
    private router: Router,
    private otherService: OtherService,
    private el: ElementRef,
    private _location: Location,
    private mapService: MapService,
    private deviceService: DeviceDetectorService,
    private route: ActivatedRoute,
    private formBuilder: FormBuilder,
    private dataService: DataService,
    private gurdService: GurdServiceService
  ) {
    Chart.register(...registerables);
    Chart.register(zoomPlugin);

  }

  dataFrom: FormGroup = this.formBuilder.group({
    date: new Date().valueOf(),
  });

  dataTo: FormGroup = this.formBuilder.group({
    date: new Date().valueOf(),
  });

  strSTime: FormControl = new FormControl("00:00");
  strETime: FormControl = new FormControl("23:59");
  modalData: any;
  iMobileDomain: number = -1;
  clusterModal: any;
  carNum: number = 0;
  domain: any;
  fileName = 'ExcelSheet.xlsx';
  carStatusData: any;
  JournalTypeData: any;
  onlinecar: number = 0;
  close3: boolean = false;
  close2: boolean = false;
  close1: boolean = false;
  close4: boolean = false;
  close5: boolean = false;
  close6: boolean = false;
  close7: boolean = false;
  groupCar: any = [];

  location: any = [51.3833554, 35.6770113];
  flon: any;
  flat: any;
  clusters: any;
  ctx1: any;
  ctx2: any;
  ctx3: any;
  ctx4: any;
  ctx5: any;
  ctx6: any;
  ctx7: any;
  ctx8: any;
  ctx9: any;
  ctx10: any;
  ctx11: any;
  ctx12: any;
  ctx13: any;
  ctx14: any;
  ctx15: any;
  ctx16: any;
  ctx17: any;
  ctx18: any;
  ctx19: any;
  obj: any;
  label: Array<any> = [];
  datachart: Array<any> = [];
  obj1: any;
  label1: Array<any> = [];
  datachart1: Array<any> = [];
  obj2: any;
  label2: Array<any> = [];
  datachart2: Array<any> = [];
  obj3: any;
  label3: Array<any> = [];
  datachart3: Array<any> = [];
  obj4: any;
  label4: Array<any> = [];
  datachart4: Array<any> = [];
  obj5: any;
  label5: Array<any> = [];
  datachart5: Array<any> = [];
  obj6: any;
  label6: Array<any> = [];
  datachart6: Array<any> = [];
  obj7: any;
  label7: Array<any> = [];
  datachart7: Array<any> = [];
  obj8: any;
  label8: Array<any> = [];
  datachart8: Array<any> = [];
  obj9: any;
  label9: Array<any> = [];
  datachart9: Array<any> = [];
  obj10: any;
  label10: Array<any> = [];
  datachart10: Array<any> = [];
  obj11: any;
  label11: Array<any> = [];
  datachart11: Array<any> = [];
  obj12: any;
  label12: Array<any> = [];
  datachart12: Array<any> = [];
  obj13: any;
  label13: Array<any> = [];
  datachart13: Array<any> = [];
  obj14: any;
  label14: Array<any> = [];
  datachart14: Array<any> = [];
  obj15: any;
  label15: Array<any> = [];
  datachart15: Array<any> = [];
  obj16: any;
  label16: Array<any> = [];
  datachart16: Array<any> = [];
  obj17: any;
  label17: Array<any> = [];
  datachart17: Array<any> = [];
  map: any = {};
  map2: any = {};
  map3: any = {};
  isDesktop: any;
  tiMobileType: any = -1;
  tabelArray: any = [];
  CHART_COLORS: any = {
    red: 'rgb(255, 99, 132)',
    orange: 'rgb(255, 159, 64)',
    yellow: 'rgb(255, 205, 86)',
    green: 'rgb(75, 192, 192)',
    blue: 'rgb(54, 162, 235)',
    purple: 'rgb(153, 102, 255)',
    grey: 'rgb(201, 203, 207)',
  };
  CHART_COLORS2: any = {
    green: 'rgb(75, 192, 192)',
    purple: 'rgb(153, 102, 255)',
    blue: 'rgb(54, 162, 235)',
    orange: 'rgb(255, 159, 64)',
    yellow: 'rgb(255, 205, 86)',
    red: 'rgb(255, 99, 132)',
    grey: 'rgb(201, 203, 207)',
  };
  CHART_COLORS3: any = {
    green: 'rgb(111, 255, 111)',
    purple: 'rgb(255, 153, 204)',
    blue: 'rgb(29, 179, 214)',
    orange: 'rgb(45, 103, 103)',
    yellow: 'rgb(251, 101, 150)',
    red: 'rgb(36, 123, 46)',
    grey: 'rgb(103, 13, 183)',
  };
  source: any;

  source2: any;

  source3: any;

  source4: any;

  vector: any;

  vector2: any;

  vector3: any;

  vector4: any;

  layers: any = [];

  layers2: any = [];

  layers3: any = [];

  layers4: any = [];

  private bOfflineMap: boolean = (<any>window).bOfflineMap;

  private strMapUrl: string = (<any>window).strMapUrl;
  ngOnInit(): void {
    this.isDesktop = this.deviceService.isDesktop();
    $('.clockpicker').clockpicker({
      donetext: 'top',
      align: 'top',
      autoclose: true,
    });

    setTimeout(() => {
      this.route.params.subscribe((params) => {
        this.getDomain();
        // if (params['id']) {
        //   this.iMobileDomain = params['id'];

        // }
        this.dataFrom.controls["date"].setValue("");
        if (this.dataService.dashbordData) {
          this.iMobileDomain = this.dataService.dashbordData.iMobileDomain
          this.tiMobileType = this.dataService.dashbordData.tiMobileType
          this.dataFrom.controls["date"].setValue(this.dataService.dashbordData.dataFrom);
          this.dataTo.controls["date"].setValue(this.dataService.dashbordData.dataTo);
          $("#Stime").val(this.dataService.dashbordData.stime);
          $("#Etime").val(this.dataService.dashbordData.etime);
        }
        this.getGroup();
        this.getCarStatus();
        this.getCarAreaService();
        this.getCarDaily();
        this.getCarHouer();
        this.getCarGauging();
        this.getCarGaugingAll();
        this.getCarGauge();
        this.getCarRepair();
        this.getCarCostly();
        this.getCarService();
        this.getCarTrafic();
        this.getCarTable();
        this.getCarGroup();
        this.getCarViolation();
        this.getCarFullViolation();
        this.getCarType();
        this.getDangerDriver();
        this.getRefueling();
        this.getCarByYear();
        this.getCarAllKm();

      })
    }, 300);

    setTimeout(() => {

      this.source = new VectorSource({ wrapX: false });

      this.source2 = new VectorSource({ wrapX: false });

      this.source3 = new VectorSource({ wrapX: false });

      this.source4 = new VectorSource({ wrapX: false });

      this.vector = new VectorLayer({

        source: this.source,

      });

      this.vector2 = new VectorLayer({

        source: this.source2,

      });

      this.vector3 = new VectorLayer({

        source: this.source3,

      });

      this.vector4 = new VectorLayer({

        source: this.source4,

      });

      if (this.bOfflineMap) {

        this.layers.push(

          new TileLayer({

            source: new XYZ({

              url: this.strMapUrl,

              attributions: 'Map data © RayanAndishehNasr' // 

            }),

          })

        );
        this.layers2.push(

          new TileLayer({

            source: new XYZ({

              url: this.strMapUrl,

              attributions: 'Map data © RayanAndishehNasr' // 

            }),

          })

        );
        this.layers3.push(

          new TileLayer({

            source: new XYZ({

              url: this.strMapUrl,

              attributions: 'Map data © RayanAndishehNasr' // 

            }),

          })

        );
        this.layers4.push(

          new TileLayer({

            source: new XYZ({

              url: this.strMapUrl,

              attributions: 'Map data © RayanAndishehNasr' // 

            }),

          })

        );

      }

      else {

        const styles = [

          'AerialWithLabelsOnDemand',

        ];

        let i, ii;

        for (i = 0, ii = styles.length; i < ii; ++i) {

          this.layers.push(
            new TileLayer({
              visible: false,
              preload: Infinity,
              source: new BingMaps({
                key: 'Ap0AObt84NcDaUThCeWOj52ZqUHv6k4TJhjLibR-DghC-semgoj-0uPbIi8r0E4j',

                imagerySet: styles[i],
              }),

            }),
          );
          this.layers2.push(
            new TileLayer({
              visible: false,
              preload: Infinity,
              source: new BingMaps({
                key: 'Ap0AObt84NcDaUThCeWOj52ZqUHv6k4TJhjLibR-DghC-semgoj-0uPbIi8r0E4j',

                imagerySet: styles[i],
              }),

            }),
          );
          this.layers3.push(
            new TileLayer({
              visible: false,
              preload: Infinity,
              source: new BingMaps({
                key: 'Ap0AObt84NcDaUThCeWOj52ZqUHv6k4TJhjLibR-DghC-semgoj-0uPbIi8r0E4j',

                imagerySet: styles[i],
              }),

            }),
          );
          this.layers4.push(
            new TileLayer({
              visible: false,
              preload: Infinity,
              source: new BingMaps({
                key: 'Ap0AObt84NcDaUThCeWOj52ZqUHv6k4TJhjLibR-DghC-semgoj-0uPbIi8r0E4j',

                imagerySet: styles[i],
              }),

            }),
          );

        }

        this.layers.push(new TileLayer({ source: new OSM({}) }), this.vector)

        this.layers2.push(new TileLayer({ source: new OSM({}) }), this.vector2)

        this.layers3.push(new TileLayer({ source: new OSM({}) }), this.vector3)

        this.layers4.push(new TileLayer({ source: new OSM({}) }), this.vector4)
      }
      this.map = new Map({
        target: "test",
        view: new View({
          zoom: 4,
          center: olProj.fromLonLat(this.location)
        }),
        layers: this.layers
      });
      this.map2 = new Map({
        target: "test2",
        view: new View({
          zoom: 4,
          center: olProj.fromLonLat(this.location)
        }),
        layers: this.layers2
      });
      this.map3 = new Map({
        target: "map",
        view: new View({
          zoom: 4,
          center: olProj.fromLonLat(this.location)
        }),
        layers: this.layers3
      });
      this.journalType();
      this.clusterData();
      this.clusterGasStation();
    }, 300);


  }
  ngAfterViewInit(): void {

  }
  search() {
    this.dataService.dashbordData = {
      dataFrom: this.dataFrom.controls["date"].value,
      dataTo: this.dataTo.controls["date"].value,
      stime: $("#Stime").val(),
      etime: $("#Etime").val(),
      iMobileDomain: $("#domainDashbord").val(),
      tiMobileType: $("#carGroup").val(),
    }
    setTimeout(() => {
      this.reloadCurrentRoute();
    }, 50);
  }
  // changeDomain(val: any) {
  //   this.iMobileDomain = val.value;


  //   //this.router.navigateByUrl(`/dashbord/${val.value}`);

  //   setTimeout(() => {
  //     this.reloadCurrentRoute(val.value);
  //   }, 50);
  // }
  goBack() {
    this.router.navigateByUrl(`/`);;
  }
  getCarAreaService = async () => {
    var model = {
      iSystemUser: this.gurdService.decrypt(window.localStorage.getItem('ID')!),
      strSession: this.gurdService.decrypt(localStorage.getItem('Session')!)
    } as any;
    model.iMobileDomain = this.iMobileDomain;
    model.tiMobileType = this.tiMobileType;
    const resp = await axios.post(`Report_MobileCountBaseMobileDomain`, model);

    let resParse = JSON.parse(resp.data);
    if (resParse.iResult == 0) {
      this.notifyService.showError(resParse.strError);
      return;

    }
    if (resParse.ISSessionExpired == true) {
      this.notifyService.showError('لطفا وارد سیستم شوید');
      this.otherService.removeLocalStorage();
      // this.router.navigate(['login']);
      this.router.navigate(['login'], { queryParams: { error: '17' } });

      return;
    }
    this.obj = resParse;
    this.label = [];
    this.datachart = [];
    this.obj.forEach((element: any) => {
      this.label.push(element.X);
      this.datachart.push(element.Y);
    });
    const ctx = document.getElementById('myChart2') as any;
    if (this.ctx1) {
      this.ctx1.destroy();
    }
    this.ctx1 = new Chart(ctx, {
      type: 'bar',
      data: {
        labels: this.label,
        datasets: [
          {
            // label: '# of Votes',
            data: this.datachart,
            backgroundColor: Object.values(this.CHART_COLORS),

            borderWidth: 1,
          },
        ],
      },
      options: {
        onClick: (e) => {
          const points = this.ctx1.getElementsAtEventForMode(e, 'nearest', { intersect: true }, true);
          const firstPoint = points[0];
          const label = this.ctx1.data.labels[firstPoint.index];
          const value = this.ctx1.data.datasets[firstPoint.datasetIndex].data[firstPoint.index];
          this.fileName = "نمودار خودرو به تفکیک حوزه.xlsx";
          this.carStatus(2, label);
        },
        responsive: true,

        interaction: {
          mode: 'nearest',
          intersect: false
        },
        plugins: {
          legend: {
            position: 'center',
            labels: {
              color: "black",
            }
          },
          zoom: {
            zoom: {
              wheel: {
                enabled: true,
              },
              pinch: {
                enabled: true
              },
              mode: 'x',
            }
          },
          title: {
            display: false,
          },
        },
        scales: {

          x: {
            ticks: {
              color: 'black',

              font: {
                //size: 25
                family: "bYekan",
                size: 12
              }
              //size: 30
            }
          },

        }
      },

    });

  }
  getCarTrafic = async () => {
    var model = {
      iSystemUser: this.gurdService.decrypt(window.localStorage.getItem('ID')!),
      strSession: this.gurdService.decrypt(localStorage.getItem('Session')!)
    } as any;
    model.iMobileDomain = this.iMobileDomain;
    model.tiMobileType = this.tiMobileType;
    model.strSDate = this.dataFrom.controls["date"].value;
    model.strEDate = this.dataTo.controls["date"].value;
    model.strSTime = $("#Stime").val();
    model.strETime = $("#Etime").val();
    const resp = await axios.post(`Report_DailyTraffic`, model);

    let resParse = JSON.parse(resp.data);
    if (resParse.iResult == 0) {
      this.notifyService.showError(resParse.strError);
      return;

    }
    if (resParse.ISSessionExpired == true) {
      this.notifyService.showError('لطفا وارد سیستم شوید');
      this.otherService.removeLocalStorage();
      // this.router.navigate(['login']);
      this.router.navigate(['login'], { queryParams: { error: '18' } });

      return;
    }
    this.obj9 = resParse;
    this.label9 = [];
    this.datachart9 = [];
    this.obj9.forEach((element: any) => {
      this.label9.push(element.X);
      this.datachart9.push(element.Y);
    });
    const ctx = document.getElementById('myChart11') as any;
    if (this.ctx2) {
      this.ctx2.destroy();
    }
    this.ctx2 = new Chart(ctx, {
      type: 'bar',
      data: {
        labels: this.label9,
        datasets: [
          {
            // label: '# of Votes',
            data: this.datachart9,
            backgroundColor: Object.values(this.CHART_COLORS2),

            borderWidth: 1,
          },
        ],
      },
      options: {
        responsive: true,
        interaction: {
          mode: 'nearest',
          intersect: false
        },
        plugins: {
          legend: {
            position: 'center',
          },
          title: {
            display: false,
          },
        },
        scales: {
          x: {
            ticks: {
              color: 'black',
              font: {
                //size: 25
                family: "bYekan",
                size: 12
              }
            }

          }
        }
      },

    });

  }
  getGroup = async () => {
    const resp = await axios.post(`GetMobileType`, {});
    this.groupCar = resp.data;
  };
  getCarType = async () => {
    var model = {
      iSystemUser: this.gurdService.decrypt(window.localStorage.getItem('ID')!),
      strSession: this.gurdService.decrypt(localStorage.getItem('Session')!)
    } as any;
    model.iMobileDomain = this.iMobileDomain;
    model.tiMobileType = this.tiMobileType;
    const resp = await axios.post(`Report_GPSType`, model);

    let resParse = JSON.parse(resp.data);
    if (resParse.iResult == 0) {
      this.notifyService.showError(resParse.strError);
      return;

    }
    if (resParse.ISSessionExpired == true) {
      this.notifyService.showError('لطفا وارد سیستم شوید');
      this.otherService.removeLocalStorage();
      // this.router.navigate(['login']);
      this.router.navigate(['login'], { queryParams: { error: '19' } });

      return;
    }
    this.obj10 = resParse;
    this.label10 = [];
    this.datachart10 = [];
    this.obj10.forEach((element: any) => {
      this.label10.push(element.X);
      this.datachart10.push(element.Y);
    });
    const ctx = document.getElementById('myChart12') as any;
    if (this.ctx3) {
      this.ctx3.destroy();
    }
    this.ctx3 = new Chart(ctx, {
      type: 'bar',
      data: {
        labels: this.label10,
        datasets: [
          {
            // label: '# of Votes',
            data: this.datachart10,
            backgroundColor: Object.values(this.CHART_COLORS3),

            borderWidth: 1,
          },
        ],
      },
      options: {
        onClick: (e) => {
          const points = this.ctx3.getElementsAtEventForMode(e, 'nearest', { intersect: true }, true);
          const firstPoint = points[0];
          const label = this.ctx3.data.labels[firstPoint.index];
          const value = this.ctx3.data.datasets[firstPoint.datasetIndex].data[firstPoint.index];
          this.fileName = "وسایل نقلیه به تفکیک نوع.xlsx";
          this.carStatus(4, label);
        },
        responsive: true,

        interaction: {
          mode: 'nearest',
          intersect: false
        },
        plugins: {
          zoom: {
            zoom: {
              wheel: {
                enabled: true,
              },
              pinch: {
                enabled: true
              },
              mode: 'x',
            }
          },
          legend: {
            position: 'center',
          },
          title: {
            display: false,
          },
        },
        scales: {
          x: {
            ticks: {
              color: 'black',
              font: {
                //size: 25
                family: "bYekan",
                size: 12
              }
            }

          }
        }
      },

    });

  }
  getCarDaily = async () => {
    var model = {
      iSystemUser: this.gurdService.decrypt(window.localStorage.getItem('ID')!),
      strSession: this.gurdService.decrypt(localStorage.getItem('Session')!)
    } as any;
    model.iMobileDomain = this.iMobileDomain;
    model.tiMobileType = this.tiMobileType;
    model.strSDate = this.dataFrom.controls["date"].value;
    model.strEDate = this.dataTo.controls["date"].value;
    model.strSTime = $("#Stime").val();
    model.strETime = $("#Etime").val();
    const resp = await axios.post(`Report_DailyKM`, model);

    let resParse = JSON.parse(resp.data);
    if (resParse.iResult == 0) {
      this.notifyService.showError(resParse.strError);
      return;

    }
    if (resParse.ISSessionExpired == true) {
      this.notifyService.showError('لطفا وارد سیستم شوید');
      this.otherService.removeLocalStorage();
      // this.router.navigate(['login']);
      this.router.navigate(['login'], { queryParams: { error: '20' } });

      return;
    }
    this.obj1 = resParse;
    this.label1 = [];
    this.datachart1 = [];
    this.obj1.forEach((element: any) => {
      this.label1.push(element.X);
      this.datachart1.push(element.Y);
    });
    const ctx = document.getElementById('myChart3') as any;
    if (this.ctx4) {
      this.ctx4.destroy();
    }
    this.ctx4 = new Chart(ctx, {
      type: 'line',
      data: {
        labels: this.label1,
        datasets: [
          {
            label: '(km) پیمایش روزانه ',
            data: this.datachart1,
            fill: false,
            borderColor: "#FF3333",
            backgroundColor: "#e755ba",
            pointBackgroundColor: "#990000",
            pointBorderColor: "#990000",
            pointRadius: 4
          },
        ],

      },

      options: {
        plugins: {
          zoom: {
            zoom: {
              wheel: {
                enabled: true,
              },
              pinch: {
                enabled: true
              },
              mode: 'x',
            }
          },
        },
        responsive: true,
        interaction: {
          mode: 'nearest',
          intersect: false
        },
        scales: {
          x: {
            ticks: {
              color: 'black',
              font: {
                //size: 25
                family: "bYekan",
                size: 12
              }

            }
          }
        }
      }
    });
  }
  getCarRepair = async () => {
    var model = {
      iSystemUser: this.gurdService.decrypt(window.localStorage.getItem('ID')!),
      strSession: this.gurdService.decrypt(localStorage.getItem('Session')!)
    } as any;
    model.iMobileDomain = this.iMobileDomain;
    model.tiMobileType = this.tiMobileType;
    const resp = await axios.post(`Report_RepairMaintenanceRecord`, model);

    let resParse = JSON.parse(resp.data);
    if (resParse.iResult == 0) {
      this.notifyService.showError(resParse.strError);
      return;

    }
    if (resParse.ISSessionExpired == true) {
      this.notifyService.showError('لطفا وارد سیستم شوید');
      this.otherService.removeLocalStorage();
      // this.router.navigate(['login']);
      this.router.navigate(['login'], { queryParams: { error: '21' } });

      return;
    }
    this.obj6 = resParse;
    this.label6 = [];
    this.datachart6 = [];
    this.obj6.forEach((element: any) => {
      this.label6.push(element.X);
      this.datachart6.push(element.Y);
    });
    const ctx = document.getElementById('myChart8') as any;
    if (this.ctx5) {
      this.ctx5.destroy();
    }
    this.ctx5 = new Chart(ctx, {
      type: 'bar',
      data: {
        labels: this.label6,
        datasets: [
          {
            label: 'هزینه تعمیرات (تومان)',
            data: this.datachart6,
            backgroundColor: Object.values(this.CHART_COLORS),

          },
        ],

      },

      options: {
        onClick: (e) => {
          const points = this.ctx5.getElementsAtEventForMode(e, 'nearest', { intersect: true }, true);
          const firstPoint = points[0];
          const label = this.ctx5.data.labels[firstPoint.index];
          const value = this.ctx5.data.datasets[firstPoint.datasetIndex].data[firstPoint.index];
          this.fileName = "نمودار بیشترین هزینه تعمیرات.xlsx";
          this.carStatus(3, label);
        },
        responsive: true,
        interaction: {
          mode: 'nearest',
          intersect: false
        },
        plugins: {
          legend: {
            position: 'center',
          },
          zoom: {
            zoom: {
              wheel: {
                enabled: true,
              },
              pinch: {
                enabled: true
              },
              mode: 'x',
            }
          },
          title: {
            display: false,
          },
        },
        scales: {
          x: {
            ticks: {
              color: 'black',
              font: {
                //size: 25
                family: "bYekan",
                size: 12
              }
            }
          }
        }
      },
    });
  }
  getDangerDriver = async () => {
    var model = {
      iSystemUser: this.gurdService.decrypt(window.localStorage.getItem('ID')!),
      strSession: this.gurdService.decrypt(localStorage.getItem('Session')!)
    } as any;
    model.iMobileDomain = this.iMobileDomain;
    model.tiMobileType = this.tiMobileType;
    const resp = await axios.post(`Report_RedDriving`, model);
    let resParse = JSON.parse(resp.data);
    if (resParse.iResult == 0) {
      this.notifyService.showError(resParse.strError);
      return;

    }
    if (resParse.ISSessionExpired == true) {
      this.notifyService.showError('لطفا وارد سیستم شوید');
      this.otherService.removeLocalStorage();
      // this.router.navigate(['login']);
      this.router.navigate(['login'], { queryParams: { error: '22' } });

      return;
    }
    this.obj14 = resParse;
    this.label14 = [];
    this.datachart14 = [];
    this.obj14.forEach((element: any) => {
      this.label14.push(element.X);
      this.datachart14.push(element.Y);
    });
    const ctx = document.getElementById('myChart16') as any;
    if (this.ctx16) {
      this.ctx16.destroy();
    }
    this.ctx16 = new Chart(ctx, {
      type: 'bar',
      data: {
        labels: this.label14,
        datasets: [
          {
            label: '',
            data: this.datachart14,
            backgroundColor: Object.values(this.CHART_COLORS3),

          },
        ],

      },

      options: {
        responsive: true,
        interaction: {
          mode: 'nearest',
          intersect: false
        },
        plugins: {
          legend: {
            position: 'center',
          },

          title: {
            display: false,
          },
        },
        scales: {
          x: {
            ticks: {
              color: 'black',
              font: {
                //size: 25
                family: "bYekan",
                size: 12
              }
            }
          }
        }
      },
    });
  }
  getRefueling = async () => {
    var model = {
      iSystemUser: this.gurdService.decrypt(window.localStorage.getItem('ID')!),
      strSession: this.gurdService.decrypt(localStorage.getItem('Session')!)
    } as any;
    model.iMobileDomain = this.iMobileDomain;
    model.tiMobileType = this.tiMobileType;
    const resp = await axios.post(`Report_MobilesFullReport`, model);
    let resParse = JSON.parse(resp.data);
    if (resParse.iResult == 0) {
      this.notifyService.showError(resParse.strError);
      return;

    }
    if (resParse.ISSessionExpired == true) {
      this.notifyService.showError('لطفا وارد سیستم شوید');
      this.otherService.removeLocalStorage();
      // this.router.navigate(['login']);
      this.router.navigate(['login'], { queryParams: { error: '23' } });

      return;
    }
    this.obj15 = resParse;
    this.label15 = [];
    this.datachart15 = [];
    this.obj15.forEach((element: any) => {
      this.label15.push(element.X);
      this.datachart15.push(element.Y);
    });
    const ctx = document.getElementById('myChart17') as any;
    if (this.ctx17) {
      this.ctx17.destroy();
    }
    this.ctx17 = new Chart(ctx, {
      type: 'bar',
      data: {
        labels: this.label15,
        datasets: [
          {
            label: '',
            data: this.datachart15,
            backgroundColor: Object.values(this.CHART_COLORS2),

          },
        ],

      },

      options: {
        responsive: true,

        interaction: {
          mode: 'nearest',
          intersect: false
        },
        plugins: {
          legend: {
            position: 'center',
          },
          zoom: {
            zoom: {
              wheel: {
                enabled: true,
              },
              pinch: {
                enabled: true
              },
              mode: 'x',
            }
          },
          title: {
            display: false,
          },
        },
        scales: {
          x: {
            ticks: {
              color: 'black',
              font: {
                //size: 25
                family: "bYekan",
                size: 12
              }
            }
          }
        }
      },
    });
  }
  getCarByYear = async () => {
    var model = {
      iSystemUser: this.gurdService.decrypt(window.localStorage.getItem('ID')!),
      strSession: this.gurdService.decrypt(localStorage.getItem('Session')!),

    } as any;
    model.iMobileDomain = this.iMobileDomain;
    model.tiMobileType = this.tiMobileType;
    const resp = await axios.post(`Report_YearConstruction`, model);
    let resParse = JSON.parse(resp.data);
    if (resParse.iResult == 0) {
      this.notifyService.showError(resParse.strError);
      return;

    }
    if (resParse.ISSessionExpired == true) {
      this.notifyService.showError('لطفا وارد سیستم شوید');
      this.otherService.removeLocalStorage();
      // this.router.navigate(['login']);
      this.router.navigate(['login'], { queryParams: { error: '24' } });

      return;
    }
    this.obj16 = resParse;
    this.label16 = [];
    this.datachart16 = [];
    this.obj16.forEach((element: any) => {
      this.label16.push(element.X);
      this.datachart16.push(element.Y);
    });
    const ctx = document.getElementById('myChart18') as any;
    if (this.ctx18) {
      this.ctx18.destroy();
    }
    this.ctx18 = new Chart(ctx, {
      type: 'bar',
      data: {
        labels: this.label16,
        datasets: [
          {
            label: '',
            data: this.datachart16,
            backgroundColor: Object.values(this.CHART_COLORS),

          },
        ],

      },

      options: {
        onClick: (e) => {
          const points = this.ctx18.getElementsAtEventForMode(e, 'nearest', { intersect: true }, true);
          const firstPoint = points[0];
          const label = this.ctx18.data.labels[firstPoint.index];
          const value = this.ctx18.data.datasets[firstPoint.datasetIndex].data[firstPoint.index];
          this.fileName = "سال ساخت.xlsx";
          this.carStatus(7, label);
        },
        responsive: true,
        interaction: {
          mode: 'nearest',
          intersect: false
        },
        plugins: {
          legend: {
            position: 'center',
          },

          title: {
            display: false,
          },
        },
        scales: {
          x: {
            ticks: {
              color: 'black',
              font: {
                //size: 25
                family: "bYekan",
                size: 12
              }
            }
          }
        }
      },
    });
  }
  getCarCostly = async () => {
    var model = {
      iSystemUser: this.gurdService.decrypt(window.localStorage.getItem('ID')!),
      strSession: this.gurdService.decrypt(localStorage.getItem('Session')!)
    } as any;
    model.iMobileDomain = this.iMobileDomain;
    model.tiMobileType = this.tiMobileType;
    const resp = await axios.post(`Report_MostExpensiveCar`, model);

    let resParse = JSON.parse(resp.data);
    if (resParse.iResult == 0) {
      this.notifyService.showError(resParse.strError);
      return;

    }
    if (resParse.ISSessionExpired == true) {
      this.notifyService.showError('لطفا وارد سیستم شوید');
      this.otherService.removeLocalStorage();
      // this.router.navigate(['login']);
      this.router.navigate(['login'], { queryParams: { error: '25' } });
      return;
    }
    this.obj7 = resParse;
    this.label7 = [];
    this.datachart7 = [];
    this.obj7.forEach((element: any) => {
      this.label7.push(element.X);
      this.datachart7.push(element.Y);
    });
    const ctx = document.getElementById('myChart9') as any;
    if (this.ctx6) {
      this.ctx6.destroy();
    }
    this.ctx6 = new Chart(ctx, {
      type: 'bar',
      data: {
        labels: this.label7,
        datasets: [
          {
            label: 'هزینه  (تومان)',
            data: this.datachart7,
            backgroundColor: Object.values(this.CHART_COLORS2),

            // fill: false,
            // borderColor: "#FF3333",
            // backgroundColor: "#e755ba",
            // pointBackgroundColor: "#990000",
            // pointBorderColor: "#990000",
            // pointRadius: 4
          },
        ],

      },

      options: {
        responsive: true,
        interaction: {
          mode: 'nearest',
          intersect: false
        },
        plugins: {
          legend: {
            position: 'center',
          },
          title: {
            display: false,
          },
          zoom: {
            zoom: {
              wheel: {
                enabled: true,
              },
              pinch: {
                enabled: true
              },
              mode: 'x',
            }
          },
        },
        scales: {
          x: {
            ticks: {
              color: 'black',
              font: {
                //size: 25
                family: "bYekan",
                size: 12
              }

            }
          }
        }
      },

    });
  }
  getCarFullViolation = async () => {
    var model = {
      iSystemUser: this.gurdService.decrypt(window.localStorage.getItem('ID')!),
      strSession: this.gurdService.decrypt(localStorage.getItem('Session')!)
    } as any;
    model.iMobileDomain = this.iMobileDomain;
    model.tiMobileType = this.tiMobileType;
    const resp = await axios.post(`Report_MostSerious`, model);

    let resParse = JSON.parse(resp.data);
    if (resParse.iResult == 0) {
      this.notifyService.showError(resParse.strError);
      return;

    }
    if (resParse.ISSessionExpired == true) {
      this.notifyService.showError('لطفا وارد سیستم شوید');
      this.otherService.removeLocalStorage();
      // this.router.navigate(['login']);
      this.router.navigate(['login'], { queryParams: { error: '26' } });
      return;
    }
    this.obj13 = resParse;
    this.label13 = [];
    this.datachart13 = [];
    this.obj13.forEach((element: any) => {
      this.label13.push(element.X);
      this.datachart13.push(element.Y);
    });
    const ctx = document.getElementById('myChart15') as any;
    if (this.ctx7) {
      this.ctx7.destroy();
    }
    this.ctx7 = new Chart(ctx, {
      type: 'bar',
      data: {
        labels: this.label13,
        datasets: [
          {
            label: 'هزینه  (تومان)',
            data: this.datachart13,
            backgroundColor: Object.values(this.CHART_COLORS3),

            // fill: false,
            // borderColor: "#FF3333",
            // backgroundColor: "#e755ba",
            // pointBackgroundColor: "#990000",
            // pointBorderColor: "#990000",
            // pointRadius: 4
          },
        ],

      },

      options: {
        responsive: true,
        interaction: {
          mode: 'nearest',
          intersect: false
        },
        plugins: {
          zoom: {
            zoom: {
              wheel: {
                enabled: true,
              },
              pinch: {
                enabled: true
              },
              mode: 'x',
            }
          },
          legend: {
            position: 'center',
          },
          title: {
            display: false,
          },
        },
        scales: {
          x: {
            ticks: {
              color: 'black',
              font: {
                //size: 25
                family: "bYekan",
                size: 12
              }

            }
          }
        }
      },

    });
  }
  getCarService = async () => {
    var model = {
      iSystemUser: this.gurdService.decrypt(window.localStorage.getItem('ID')!),
      strSession: this.gurdService.decrypt(localStorage.getItem('Session')!)
    } as any;
    model.iMobileDomain = this.iMobileDomain;
    model.tiMobileType = this.tiMobileType;

    const resp = await axios.post(`Report_RepairMaintenanceCondition `, model);

    let resParse = JSON.parse(resp.data);
    if (resParse.iResult == 0) {
      this.notifyService.showError(resParse.strError);
      return;

    }
    if (resParse.ISSessionExpired == true) {
      this.notifyService.showError('لطفا وارد سیستم شوید');
      this.otherService.removeLocalStorage();
      // this.router.navigate(['login']);
      this.router.navigate(['login'], { queryParams: { error: '27' } });

      return;
    }
    this.obj8 = resParse;
    this.label8 = [];
    this.datachart7 = [];
    this.obj8.forEach((element: any) => {
      this.label8.push(element.X);
      this.datachart8.push(element.Y);
    });
    const ctx = document.getElementById('myChart10') as any;
    if (this.ctx8) {
      this.ctx8.destroy();
    }
    this.ctx8 = new Chart(ctx, {
      type: 'bar',
      data: {
        labels: this.label8,
        datasets: [
          {
            // label: '# of Votes',
            data: this.datachart8,
            backgroundColor: Object.values(this.CHART_COLORS3),

            borderWidth: 1,
          },
        ],
      },
      options: {
        onClick: (e) => {
          const points = this.ctx8.getElementsAtEventForMode(e, 'nearest', { intersect: true }, true);
          const firstPoint = points[0];
          const label = this.ctx8.data.labels[firstPoint.index];
          const value = this.ctx8.data.datasets[firstPoint.datasetIndex].data[firstPoint.index];
          this.fileName = "سررسید سرویس های دوره ای.xlsx";
          this.carStatus(6, label);
        },
        responsive: true,
        interaction: {
          mode: 'nearest',
          intersect: false
        },
        plugins: {
          legend: {
            position: 'center',
          },
          title: {
            display: false,
          },

        },
        scales: {
          x: {
            ticks: {
              color: 'black',
              font: {
                //size: 25
                family: "bYekan",
                size: 12
              }
            }
          },
          y: {
            ticks: {
              stepSize: 1
            }
          }
        }
      },
    });
  }
  getCarGauge = async () => {
    var model = {
      iSystemUser: this.gurdService.decrypt(window.localStorage.getItem('ID')!),
      strSession: this.gurdService.decrypt(localStorage.getItem('Session')!)
    } as any;
    model.iMobileDomain = this.iMobileDomain;
    model.tiMobileType = this.tiMobileType;
    const resp = await axios.post(`Report_VehicleStatusGatch`, model);
    let resParse = JSON.parse(resp.data);
    if (resParse.iResult == 0) {
      this.notifyService.showError(resParse.strError);
      return;

    }
    if (resParse.ISSessionExpired == true) {
      this.notifyService.showError('لطفا وارد سیستم شوید');
      this.otherService.removeLocalStorage();
      // this.router.navigate(['login']);
      this.router.navigate(['login'], { queryParams: { error: '28' } });

      return;
    }
    this.onlinecar = resParse[0].CurrentValue;
    this.carNum = resParse[0].Maximume;
    this.ctx15 = new Chart('myChart', {
      type: 'doughnut',
      plugins: [{
        afterDraw: (chart: any) => {
          // var needleValue = chart.config.data.datasets[0].needleValue;
          // var dataTotal = chart.config.data.datasets[0].data.reduce((a: any, b: any) => a + b, 0);
          var angle = Math.PI + (1 / resParse[0].Maximume * resParse[0].CurrentValue * Math.PI);
          var ctx = chart.ctx;
          var cw = chart.canvas.offsetWidth;
          var ch = chart.canvas.offsetHeight;
          var cx = cw / 2;
          var cy = ch - 6;

          ctx.translate(cx, cy);
          ctx.rotate(angle);
          ctx.beginPath();
          ctx.moveTo(0, -3);
          ctx.lineTo(ch - 20, 0);
          ctx.lineTo(0, 3);
          ctx.fillStyle = 'rgb(0, 0, 0)';
          ctx.fill();
          ctx.rotate(-angle);
          ctx.translate(-cx, -cy);
          ctx.beginPath();
          ctx.arc(cx, cy, 5, 0, Math.PI * 2);
          ctx.fill();
        }
      }] as any,
      data: {
        labels: [],
        datasets: [{
          data: [resParse[0].Maximume / 3, resParse[0].Maximume / 3, resParse[0].Maximume / 3],
          needleValue: 27,
          backgroundColor: [
            'rgba(255, 99, 132, 0.2)',
            'rgba(255, 206, 86, 0.2)',
            'rgba(63, 191, 63, 0.2)'
          ]
        }] as any
      },
      options: {
        responsive: false,
        aspectRatio: 2,
        layout: {
          padding: {
            bottom: 3
          }

        },

        rotation: -90,
        cutout: '50%',
        circumference: 180,
        animation: {
          animateRotate: false,
          animateScale: true
        }
      }
    });
  }
  getCarStatus = async () => {
    var model = {
      iSystemUser: this.gurdService.decrypt(window.localStorage.getItem('ID')!),
      strSession: this.gurdService.decrypt(localStorage.getItem('Session')!)
    } as any;
    model.iMobileDomain = this.iMobileDomain;
    model.tiMobileType = this.tiMobileType;
    const resp = await axios.post(`Report_VehicleStatus`, model);
    let resParse = JSON.parse(resp.data);
    if (resParse.iResult == 0) {
      this.notifyService.showError(resParse.strError);
      return;

    }
    if (resParse.ISSessionExpired == true) {
      this.notifyService.showError('لطفا وارد سیستم شوید');
      this.otherService.removeLocalStorage();
      // this.router.navigate(['login']);
      this.router.navigate(['login'], { queryParams: { error: '29' } });

      return;
    }
    this.obj2 = resParse;
    this.obj2.forEach((element: any) => {
      this.label2.push(element.X);
      this.datachart2.push(element.Y);
    });
    // const ctx = document.getElementById('myChart4') as any;
    var canvas = document.getElementById("myChart4") as any;
    var ctx = canvas.getContext("2d");
    const DATA_COUNT = 5;
    const data = {
      labels: this.label2,
      datasets: [
        {
          data: this.datachart2,
          backgroundColor: Object.values(this.CHART_COLORS3),
        },
      ],
    } as any;
    if (this.ctx9) {
      this.ctx9.destroy();
    }
    this.ctx9 = new Chart(ctx, {
      type: 'pie',
      data: data,
      options: {
        onClick: (e) => {
          const points = this.ctx9.getElementsAtEventForMode(e, 'nearest', { intersect: true }, true);
          const firstPoint = points[0];
          const label = this.ctx9.data.labels[firstPoint.index];
          const value = this.ctx9.data.datasets[firstPoint.datasetIndex].data[firstPoint.index];
          this.fileName = "نمودارد وضعیت خودروها.xlsx";
          this.carStatus(1, label);
        },
        responsive: true,
        interaction: {
          mode: 'nearest',
          intersect: false
        },
        plugins: {
          legend: {
            position: 'top',
            labels: {
              color: "black",
            }
          },
          title: {
            display: false,
          },
        },

      },
    });

    var chartEl = document.getElementById("myChart4") as any;
    chartEl.height = 200;

  }
  timeSlotEdit(event: any, array: any) {
    let activeElement = this.ctx9.current.getElementAtEvent(event);
  }
  getCarGroup = async () => {
    var model = {
      iSystemUser: this.gurdService.decrypt(window.localStorage.getItem('ID')!),
      strSession: this.gurdService.decrypt(localStorage.getItem('Session')!)
    } as any;
    model.iMobileDomain = this.iMobileDomain;
    model.tiMobileType = this.tiMobileType;
    const resp = await axios.post(`Report_MobileType`, model);

    let resParse = JSON.parse(resp.data);
    if (resParse.iResult == 0) {
      this.notifyService.showError(resParse.strError);
      return;

    }
    if (resParse.ISSessionExpired == true) {
      this.notifyService.showError('لطفا وارد سیستم شوید');
      this.otherService.removeLocalStorage();
      // this.router.navigate(['login']);
      this.router.navigate(['login'], { queryParams: { error: '30' } });

      return;
    }
    this.obj11 = resParse;
    this.obj11.forEach((element: any) => {
      this.label11.push(element.X);
      this.datachart11.push(element.Y);
    });
    const ctx = document.getElementById('myChart13') as any;
    const DATA_COUNT = 5;
    const data = {
      labels: this.label11,
      datasets: [
        {
          data: this.datachart11,
          backgroundColor: Object.values(this.CHART_COLORS),
        },
      ],
    } as any;
    if (this.ctx10) {
      this.ctx10.destroy();
    }
    this.ctx10 = new Chart(ctx, {
      type: 'pie',
      data: data,
      options: {
        onClick: (e) => {
          const points = this.ctx10.getElementsAtEventForMode(e, 'nearest', { intersect: true }, true);
          const firstPoint = points[0];
          const label = this.ctx10.data.labels[firstPoint.index];
          const value = this.ctx10.data.datasets[firstPoint.datasetIndex].data[firstPoint.index];
          this.fileName = "وسایل نقلیه به تفکیک گروه.xlsx";

          this.carStatus(5, label);
        },
        responsive: true,
        interaction: {
          mode: 'nearest',
          intersect: false
        },
        plugins: {
          legend: {
            position: 'top',
            labels: {
              color: "black",
            }
          },
          title: {
            display: false,
          },
        },

      },
    });
    var chartEl = document.getElementById("myChart13") as any;
    chartEl.height = 200;
  }
  getCarViolation = async () => {
    var model = {
      iSystemUser: this.gurdService.decrypt(window.localStorage.getItem('ID')!),
      strSession: this.gurdService.decrypt(localStorage.getItem('Session')!)
    } as any;
    model.iMobileDomain = this.iMobileDomain;
    model.tiMobileType = this.tiMobileType;
    const resp = await axios.post(`Report_Journal`, model);
    let resParse = JSON.parse(resp.data);
    if (resParse.iResult == 0) {
      this.notifyService.showError(resParse.strError);
      return;

    }
    if (resParse.ISSessionExpired == true) {
      this.notifyService.showError('لطفا وارد سیستم شوید');
      this.otherService.removeLocalStorage();
      // this.router.navigate(['login']);
      this.router.navigate(['login'], { queryParams: { error: '31' } });

      return;
    }
    this.obj12 = resParse;
    this.obj12.forEach((element: any) => {
      this.label12.push(element.X);
      this.datachart12.push(element.Y);
    });
    const ctx = document.getElementById('myChart14') as any;
    const DATA_COUNT = 5;
    const data = {
      labels: this.label12,
      datasets: [
        {
          data: this.datachart12,
          backgroundColor: Object.values(this.CHART_COLORS2),
        },
      ],
    } as any;
    if (this.ctx11) {
      this.ctx11.destroy();
    }
    this.ctx11 = new Chart(ctx, {
      type: 'pie',
      data: data,
      options: {
        responsive: true,
        interaction: {
          mode: 'nearest',
          intersect: false
        },
        plugins: {

          legend: {
            position: 'top',
            labels: {
              color: "black",
            }
          },
          title: {
            display: false,
          },
        },

      },
    });
    var chartEl = document.getElementById("myChart14") as any;
    chartEl.height = 200;
  }
  getCarHouer = async () => {
    var model = {
      iSystemUser: this.gurdService.decrypt(window.localStorage.getItem('ID')!),
      strSession: this.gurdService.decrypt(localStorage.getItem('Session')!)
    } as any;
    model.iMobileDomain = this.iMobileDomain;
    model.tiMobileType = this.tiMobileType;
    model.strSDate = this.dataFrom.controls["date"].value;
    model.strEDate = this.dataTo.controls["date"].value;
    model.strSTime = $("#Stime").val();
    model.strETime = $("#Etime").val();

    const resp = await axios.post(`Report_DailyTime`, model);

    let resParse = JSON.parse(resp.data);
    if (resParse.iResult == 0) {
      this.notifyService.showError(resParse.strError);
      return;

    }
    if (resParse.ISSessionExpired == true) {
      this.notifyService.showError('لطفا وارد سیستم شوید');
      this.otherService.removeLocalStorage();
      // this.router.navigate(['login']);
      this.router.navigate(['login'], { queryParams: { error: '32' } });

      return;
    }
    this.obj3 = resParse;
    this.label3 = [];
    this.datachart3 = [];
    this.obj3.forEach((element: any) => {
      this.label3.push(element.X);
      this.datachart3.push(element.Y);
    });
    const ctx = document.getElementById('myChart5') as any;
    if (this.ctx12) {
      this.ctx12.destroy();
    }
    this.ctx12 = new Chart(ctx, {
      type: 'line',
      data: {
        labels: this.label3,
        datasets: [
          {
            label: 'جمع ساعت ',
            data: this.datachart3,
            fill: false,
            borderColor: "#FF3333",
            backgroundColor: "#e755ba",
            pointBackgroundColor: "#990000",
            pointBorderColor: "#990000",
            pointRadius: 4
          },
        ],

      },

      options: {
        plugins: {
          zoom: {
            zoom: {
              wheel: {
                enabled: true,
              },
              pinch: {
                enabled: true
              },
              mode: 'x',
            }
          },
        },
        responsive: true,
        interaction: {
          mode: 'nearest',
          intersect: false
        },
        scales: {
          x: {
            ticks: {
              color: 'black',
              font: {
                //size: 25
                family: "bYekan",
                size: 12
              }
            }
          }
        }
      }
    });
  }
  getCarGauging = async () => {
    var model = {
      iSystemUser: this.gurdService.decrypt(window.localStorage.getItem('ID')!),
      strSession: this.gurdService.decrypt(localStorage.getItem('Session')!)
    } as any;
    model.iMobileDomain = this.iMobileDomain;
    model.tiMobileType = this.tiMobileType;
    model.strSDate = this.dataFrom.controls["date"].value;
    model.strEDate = this.dataTo.controls["date"].value;
    model.strSTime = $("#Stime").val();
    model.strETime = $("#Etime").val();
    const resp = await axios.post(`Report_DailyMobileKM`, model);

    let resParse = JSON.parse(resp.data);
    if (resParse.iResult == 0) {
      this.notifyService.showError(resParse.strError);
      return;

    }
    if (resParse.ISSessionExpired == true) {
      this.notifyService.showError('لطفا وارد سیستم شوید');
      this.otherService.removeLocalStorage();
      // this.router.navigate(['login']);
      this.router.navigate(['login'], { queryParams: { error: '33' } });

      return;
    }
    this.obj4 = resParse;
    this.label4 = [];
    this.datachart4 = [];
    this.obj4.forEach((element: any) => {
      this.label4.push(element.X);
      this.datachart4.push(element.Y);
    });
    const ctx = document.getElementById('myChart6') as any;
    if (this.ctx13) {
      this.ctx13.destroy();
    }
    this.ctx13 = new Chart(ctx, {
      type: 'bar',
      data: {
        labels: this.label4,
        datasets: [
          {
            // label: '# of Votes',
            data: this.datachart4,
            backgroundColor: Object.values(this.CHART_COLORS2),

            borderWidth: 1,
          },
        ],
      },
      options: {
        responsive: true,
        interaction: {
          mode: 'nearest',
          intersect: false
        },
        plugins: {

          zoom: {
            zoom: {
              wheel: {
                enabled: true,
              },
              pinch: {
                enabled: true
              },
              mode: 'x',
            }
          },
          legend: {
            position: 'center',
          },
          title: {
            display: false,
          },
        },
        scales: {
          x: {
            ticks: {
              color: 'black',
              font: {
                //size: 25
                family: "bYekan",
                size: 12
              }

            }
          }
        }
      },
    });

  }
  getCarGaugingAll = async () => {

    var model = {
      iSystemUser: this.gurdService.decrypt(window.localStorage.getItem('ID')!),
      strSession: this.gurdService.decrypt(localStorage.getItem('Session')!)
    } as any;
    model.iMobileDomain = this.iMobileDomain;
    model.tiMobileType = this.tiMobileType;

    model.strSDate = this.dataFrom.controls["date"].value;
    model.strEDate = this.dataTo.controls["date"].value;
    model.strSTime = $("#Stime").val();
    model.strETime = $("#Etime").val();
    const resp = await axios.post(`Report_TotalMobileKM`, model);
    let resParse = JSON.parse(resp.data);
    if (resParse.iResult == 0) {
      this.notifyService.showError(resParse.strError);
      return;

    }
    if (resParse.ISSessionExpired == true) {
      this.notifyService.showError('لطفا وارد سیستم شوید');
      this.otherService.removeLocalStorage();
      // this.router.navigate(['login']);
      this.router.navigate(['login'], { queryParams: { error: '34' } });

      return;
    }
    this.obj5 = resParse;
    this.label5 = [];
    this.datachart5 = [];
    this.obj5.forEach((element: any) => {
      this.label5.push(element.X);
      this.datachart5.push(element.Y);
    });
    const ctx = document.getElementById('myChart7') as any;
    if (this.ctx14) {
      this.ctx14.destroy();
    }
    this.ctx14 = new Chart(ctx, {
      type: 'bar',
      data: {
        labels: this.label5,
        datasets: [
          {
            // label: '# of Votes',
            data: this.datachart5,
            backgroundColor: Object.values(this.CHART_COLORS3),

            borderWidth: 1,
          },
        ],
      },
      options: {
        responsive: true,
        interaction: {
          mode: 'nearest',
          intersect: false
        },
        plugins: {
          legend: {
            position: 'center',
          },
          zoom: {
            zoom: {
              wheel: {
                enabled: true,
              },
              pinch: {
                enabled: true
              },
              mode: 'x',
            }
          },
          title: {
            display: false,
          },
        },
        scales: {
          x: {
            ticks: {
              color: 'black',
              font: {
                //size: 25
                family: "bYekan",
                size: 12
              }
            }
          }
        }
      },
    });

  }
  getCarAllKm = async () => {

    var model = {
      iSystemUser: this.gurdService.decrypt(window.localStorage.getItem('ID')!),
      strSession: this.gurdService.decrypt(localStorage.getItem('Session')!)
    } as any;
    model.iMobileDomain = this.iMobileDomain;
    model.tiMobileType = this.tiMobileType;

    model.strSDate = this.dataFrom.controls["date"].value;
    model.strEDate = this.dataTo.controls["date"].value;
    model.strSTime = $("#Stime").val();
    model.strETime = $("#Etime").val();
    const resp = await axios.post(`Report_TotalMobileKMBasiEnterance`, model);
    let resParse = JSON.parse(resp.data);
    if (resParse.iResult == 0) {
      this.notifyService.showError(resParse.strError);
      return;

    }
    if (resParse.ISSessionExpired == true) {
      this.notifyService.showError('لطفا وارد سیستم شوید');
      this.otherService.removeLocalStorage();
      // this.router.navigate(['login']);
      this.router.navigate(['login'], { queryParams: { error: '35' } });

      return;
    }
    this.obj17 = resParse;
    this.label17 = [];
    this.datachart17 = [];
    this.obj17.forEach((element: any) => {
      this.label17.push(element.X);
      this.datachart17.push(element.Y);
    });
    const ctx19 = document.getElementById('myChart19') as any;
    if (this.ctx19) {
      this.ctx14.destroy();
    }
    this.ctx19 = new Chart(ctx19, {
      type: 'bar',
      data: {
        labels: this.label17,
        datasets: [
          {
            // label: '# of Votes',
            data: this.datachart17,
            backgroundColor: Object.values(this.CHART_COLORS2),

            borderWidth: 1,
          },
        ],
      },
      options: {
        plugins: {
          legend: {
            position: 'center',
          },
          zoom: {
            zoom: {
              wheel: {
                enabled: true,
              },
              pinch: {
                enabled: true
              },
              mode: 'x',
            }
          },
          title: {
            display: false,
          },
        },
        scales: {
          x: {
            ticks: {
              color: 'black',
              font: {
                //size: 25
                family: "bYekan",
                size: 12
              }
            }
          }
        }
      },
    });

  }
  newOpenMap() {
    this.map = new Map({
      interactions: defaultInteractions().extend([new DragRotateAndZoom()]),
      target: 'test',
      layers: [
        new TileLayer({
          source: new OSM({}),
        })
      ],
      view: new View({
        center: olProj.fromLonLat(this.location),
        zoom: 5,
      }),
    });

    //context menu
  }
  clusterData = async () => {
    var model = {
      iSystemUser: this.gurdService.decrypt(window.localStorage.getItem('ID')!),
      strSession: this.gurdService.decrypt(localStorage.getItem('Session')!)
    } as any;
    model.iMobileDomain = this.iMobileDomain;
    model.tiMobileType = this.tiMobileType;
    const resp = await axios.post(`Report_MobileCluster`, model);
    let resParse = JSON.parse(resp.data);
    if (resParse.iResult == 0) {
      this.notifyService.showError(resParse.strError);
      return;

    }
    if (resParse.ISSessionExpired == true) {
      this.notifyService.showError('لطفا وارد سیستم شوید');
      this.otherService.removeLocalStorage();
      // this.router.navigate(['login']);

      this.router.navigate(['login'], { queryParams: { error: '36' } });

      return;
    }
    this.clustersLayer(resParse);
  }
  clusterGasStation = async () => {
    var model = {
      iSystemUser: this.gurdService.decrypt(window.localStorage.getItem('ID')!),
      strSession: this.gurdService.decrypt(localStorage.getItem('Session')!)
    } as any;
    model.iMobileDomain = this.iMobileDomain;
    model.tiMobileType = this.tiMobileType;
    const resp = await axios.post(`Report_GeoFullReport`, model);
    let resParse = JSON.parse(resp.data);
    if (resParse.iResult == 0) {
      this.notifyService.showError(resParse.strError);
      return;

    }
    if (resParse.ISSessionExpired == true) {
      this.notifyService.showError('لطفا وارد سیستم شوید');
      this.otherService.removeLocalStorage();
      // this.router.navigate(['login']);
      this.router.navigate(['login'], { queryParams: { error: '37' } });

      return;
    }
    this.clustersLayer3(resParse);
  }
  journalType = async () => {
    var model = {
      iSystemUser: this.gurdService.decrypt(window.localStorage.getItem('ID')!),
      strSession: this.gurdService.decrypt(localStorage.getItem('Session')!)
    } as any;
    const resp = await axios.post(`GetJournalType`, model);
    this.JournalTypeData = JSON.parse(resp.data);
    if (this.JournalTypeData.iResult == 0) {
      this.notifyService.showError(this.JournalTypeData.strError);
      return;

    }
    if (this.JournalTypeData.ISSessionExpired == true) {
      this.notifyService.showError('لطفا وارد سیستم شوید');
      this.otherService.removeLocalStorage();
      // this.router.navigate(['login']);
      this.router.navigate(['login'], { queryParams: { error: '38' } });

      return;
    }
    model.tiJournalType = this.JournalTypeData[0].tiJournalType;
    model.iMobileDomain = this.iMobileDomain;
    model.tiMobileType = this.tiMobileType;
    const resp2 = await axios.post(`Report_GeoJournal`, model);
    this.clustersLayer2(JSON.parse(resp2.data));
  }
  journalTypeChange = async (val: any) => {
    var model = {
      iSystemUser: this.gurdService.decrypt(window.localStorage.getItem('ID')!),
      strSession: this.gurdService.decrypt(localStorage.getItem('Session')!)
    } as any;
    model.tiJournalType = val.value;
    model.iMobileDomain = this.iMobileDomain;
    model.tiMobileType = this.tiMobileType;
    const resp2 = await axios.post(`Report_GeoJournal`, model);
    this.clustersLayer2(JSON.parse(resp2.data));

  }

  clustersLayer(data: any) {
    setTimeout(() => {
      this.map.on('click', (e: any) => {
        if (e.dragging) {
          //...
          return;
        }

        var el = this.mapService.mapPointerMove(
          this.map.getEventPixel(e.originalEvent),
          this.map
        );
        this.showData(el);
        $("#link").click(() => {
          var tooltip = $('#map_tooltip');
          tooltip.tooltip('hide');

        });
      });
      this.map.getView().on('propertychange', function (e: any) {
        var tooltip = $('#map_tooltip');
        tooltip.tooltip('hide');
      });
    }, 200);
    // Cluster Source
    var clusterSource = new Cluster({
      distance: 40,
      source: new Vector()
    }) as any;

    // Addfeatures to the cluster
    let addFeatures = (nb: any) => {
      var ext = this.map.getView().calculateExtent(this.map.getSize());
      var features = [];

      for (var i = 0; i < data.length; ++i) {
        features[i] = new Feature({
          // new Point (this.mapService.transformCoordinates2([
          //   data[i].dLongitude,
          //   data[i].dLatitude])

          // ),
          // data: data,
          type: 'removable',
          geometry: new Point(this.mapService.transformCoordinates2([
            data[i].dLongitude,
            data[i].dLatitude])

          ),
          id_: data[i].strUnitId,
          data: {
            Id: data[i].strUnitId,
            strFullName: data[i].strFullName,
            strDate: data[i].strDate,
            strMobile: data[i].strMobile,
            strTime: data[i].strTime,
            strVehicleNo: data[i].strVehicleNo,
            strMobileType_strComment: data[i].strMobileType_strComment,


            // html: `${data[i].strFullName}`,
          },
        });
        features[i].set("id", i);
      }
      clusterSource.getSource().clear();
      clusterSource.getSource().addFeatures(features);


    }

    // Style for the clusters
    var styleCache = {} as any;
    function getStyle(feature: any, resolution: any) {
      var size = feature.get("features").length;
      var style = styleCache[size];
      if (!style) {
        var color = size > 25 ? "192,0,0" : size > 8 ? "255,128,0" : "0,128,0";
        var radius = Math.max(8, Math.min(size * 0.75, 20));
        var dash = (2 * Math.PI * radius) / 6;
        var dashs = [0, dash, dash, dash, dash, dash, dash];
        style = styleCache[size] = new Style({
          image: new Circle({
            radius: radius,
            stroke: new Stroke({
              color: "rgba(" + color + ",0.5)",
              width: 15,
              lineDash: dashs,
              lineCap: "butt"
            }),
            fill: new Fill({
              color: "rgba(" + color + ",1)"
            })
          }),
          text: new Text({
            text: size.toString(),
            fill: new Fill({
              color: "#fff"
            })
          })
        });
      }
      return style;
    }

    // Animated cluster layer
    var clusterLayer = new AnimatedCluster({
      //name: "Cluster",
      source: clusterSource,
      animationDuration: 700,
      // Cluster style
      style: getStyle
    });
    this.map.addLayer(clusterLayer);
    // add 2000 features
    addFeatures(2000);

    var style1 = new Style({
      image: new Circle({
        radius: 5,
        stroke: new Stroke({
          color: "rgba(128,0,0,0.8)",
          width: 2
        }),
        fill: new Fill({
          color: "rgba(128,0,0,0.8)"
        })
      }),
      // Draw a link beetween points (or not)
      stroke: new Stroke({
        color: "#fff",
        width: 1
      })
    });
    // Select interaction to spread cluster out and select features
    var selectCluster = new SelectCluster({
      // Point radius: to calculate distance between the features
      pointRadius: 7,
      animate: true,
      // Feature style when it springs apart
      featureStyle: function () {
        return [style1];
      },
      // selectCluster: false,	// disable cluster selection
      // Style to draw cluster when selected
      style: function (f, res) {
        var cluster = f.get("features");
        if (cluster.length > 1) {
          return getStyle(f, res);
        } else {
          return [
            new Style({
              image: new Circle({
                stroke: new Stroke({
                  color: "rgba(0,0,192,0.5)",
                  width: 2
                }),
                fill: new Fill({ color: "rgba(0,0,192,0.3)" }),
                radius: 5
              })
            })
          ];
        }
      }
    });
    this.map.addInteraction(selectCluster);


  }
  clustersLayer2(data: any) {
    setTimeout(() => {
      this.map2.on('click', (e: any) => {
        if (e.dragging) {
          //...
          return;
        }

        var el = this.mapService.mapPointerMove(
          this.map2.getEventPixel(e.originalEvent),
          this.map2
        );
        this.showData(el);
        $("#link").click(() => {
          var tooltip = $('#map_tooltip');
          tooltip.tooltip('hide');

        });
      });
      this.map.getView().on('propertychange', function (e: any) {
        var tooltip = $('#map_tooltip');
        tooltip.tooltip('hide');
      });
    }, 200);
    // Cluster Source
    this.mapService.removeLayerByName("Cluster", this.map2);
    var clusterSource = new Cluster({
      distance: 40,
      source: new Vector()
    }) as any;
    setTimeout(() => {
      this.map2.getView().animate({
        zoom: this.map2.getView().getZoom() - 0.001,
        duration: 250
      })
      // Addfeatures to the cluster
      let addFeatures = (nb: any) => {
        var ext = this.map2.getView().calculateExtent(this.map2.getSize());
        var features = [];

        for (var i = 0; i < data.length; ++i) {
          features[i] = new Feature({
            // new Point (this.mapService.transformCoordinates2([
            //   data[i].dLongitude,
            //   data[i].dLatitude])

            // ),
            // data: data,
            type: 'removable',
            geometry: new Point(this.mapService.transformCoordinates2([
              data[i].fLon,
              data[i].fLat])

            ),
            id_: data[i].strUnitId,
            data: {
              Id: data[i].strUnitId,
              strFullName: data[i].strFullName,
              strDate: data[i].strDate,
              strMobile: data[i].strMobile,
              strTime: data[i].strTime,
              strVehicleNo: data[i].strVehicleNo,
              strMobileType_strComment: data[i].strMobileType_strComment,
              strJournalType_strComment: data[i].strJournalType_strComment,
              tiMaxSpeed: data[i].tiMaxSpeed,
              strComment: data[i].strComment,



              // html: `${data[i].strFullName}`,
            },
          });
          features[i].set("id", i);
        }
        clusterSource.getSource().clear();
        clusterSource.getSource().addFeatures(features);


      }

      // Style for the clusters
      var styleCache = {} as any;
      function getStyle(feature: any, resolution: any) {
        var size = feature.get("features").length;
        var style = styleCache[size];
        if (!style) {
          var color = size > 25 ? "192,0,0" : size > 8 ? "255,128,0" : "0,128,0";
          var radius = Math.max(8, Math.min(size * 0.75, 20));
          var dash = (2 * Math.PI * radius) / 6;
          var dashs = [0, dash, dash, dash, dash, dash, dash];
          style = styleCache[size] = new Style({
            image: new Circle({
              radius: radius,
              stroke: new Stroke({
                color: "rgba(" + color + ",0.5)",
                width: 15,
                lineDash: dashs,
                lineCap: "butt"
              }),
              fill: new Fill({
                color: "rgba(" + color + ",1)"
              })
            }),
            text: new Text({
              text: size.toString(),
              fill: new Fill({
                color: "#fff"
              })
            })
          });
        }
        return style;
      }

      // Animated cluster layer
      var clusterLayer = new AnimatedCluster({
        name: "Cluster",
        source: clusterSource,
        animationDuration: 700,
        // Cluster style
        style: getStyle
      } as any);
      this.map2.addLayer(clusterLayer);
      // add 2000 features
      addFeatures(2000);

      var style1 = new Style({
        image: new Circle({
          radius: 5,
          stroke: new Stroke({
            color: "rgba(128,0,0,0.8)",
            width: 2
          }),
          fill: new Fill({
            color: "rgba(128,0,0,0.8)"
          })
        }),
        // Draw a link beetween points (or not)
        stroke: new Stroke({
          color: "#fff",
          width: 1
        })
      });
      // Select interaction to spread cluster out and select features
      var selectCluster = new SelectCluster({
        // Point radius: to calculate distance between the features
        pointRadius: 7,
        animate: true,
        // Feature style when it springs apart
        featureStyle: function () {
          return [style1];
        },
        // selectCluster: false,	// disable cluster selection
        // Style to draw cluster when selected
        style: function (f, res) {
          var cluster = f.get("features");
          if (cluster.length > 1) {
            return getStyle(f, res);
          } else {
            return [
              new Style({
                image: new Circle({
                  stroke: new Stroke({
                    color: "rgba(0,0,192,0.5)",
                    width: 2
                  }),
                  fill: new Fill({ color: "rgba(0,0,192,0.3)" }),
                  radius: 5
                })
              })
            ];
          }
        }
      });
      this.map2.addInteraction(selectCluster);
    }, 50);



  }
  clustersLayer3(data: any) {
    setTimeout(() => {
      this.map3.on('click', (e: any) => {
        if (e.dragging) {
          //...
          return;
        }

        var el = this.mapService.mapPointerMove(
          this.map3.getEventPixel(e.originalEvent),
          this.map3
        );
        this.showData(el);
        $("#link").click(() => {
          var tooltip = $('#map_tooltip');
          tooltip.tooltip('hide');

        });
      });
      this.map3.getView().on('propertychange', function (e: any) {
        var tooltip = $('#map_tooltip');
        tooltip.tooltip('hide');
      });
    }, 200);
    // Cluster Source
    this.mapService.removeLayerByName("Cluster", this.map3);
    var clusterSource = new Cluster({
      distance: 40,
      source: new Vector()
    }) as any;
    setTimeout(() => {
      this.map3.getView().animate({
        zoom: this.map3.getView().getZoom() - 0.001,
        duration: 250
      })
      // Addfeatures to the cluster
      let addFeatures = (nb: any) => {
        var ext = this.map3.getView().calculateExtent(this.map3.getSize());
        var features = [];

        for (var i = 0; i < data.length; ++i) {
          features[i] = new Feature({
            // new Point (this.mapService.transformCoordinates2([
            //   data[i].dLongitude,
            //   data[i].dLatitude])

            // ),
            // data: data,
            type: 'removable',
            geometry: new Point(this.mapService.transformCoordinates2([
              data[i].fLon,
              data[i].fLat])

            ),
            id_: data[i].strUnitId,
            data: {
              // Id: data[i].strUnitId,
              // strFullName: data[i].strFullName,
              // strDate: data[i].strDate,
              // strMobile: data[i].strMobile,
              // strTime: data[i].strTime,
              // strVehicleNo: data[i].strVehicleNo,
              // strMobileType_strComment: data[i].strMobileType_strComment,
              // strJournalType_strComment: data[i].strJournalType_strComment,
              // tiMaxSpeed: data[i].tiMaxSpeed,
              // strComment: data[i].strComment,



              // html: `${data[i].strFullName}`,
            },
          });
          features[i].set("id", i);
        }
        clusterSource.getSource().clear();
        clusterSource.getSource().addFeatures(features);


      }

      // Style for the clusters
      var styleCache = {} as any;
      function getStyle(feature: any, resolution: any) {
        var size = feature.get("features").length;
        var style = styleCache[size];
        if (!style) {
          var color = size > 25 ? "192,0,0" : size > 8 ? "255,128,0" : "0,128,0";
          var radius = Math.max(8, Math.min(size * 0.75, 20));
          var dash = (2 * Math.PI * radius) / 6;
          var dashs = [0, dash, dash, dash, dash, dash, dash];
          style = styleCache[size] = new Style({
            image: new Circle({
              radius: radius,
              stroke: new Stroke({
                color: "rgba(" + color + ",0.5)",
                width: 15,
                lineDash: dashs,
                lineCap: "butt"
              }),
              fill: new Fill({
                color: "rgba(" + color + ",1)"
              })
            }),
            text: new Text({
              text: size.toString(),
              fill: new Fill({
                color: "#fff"
              })
            })
          });
        }
        return style;
      }

      // Animated cluster layer
      var clusterLayer = new AnimatedCluster({
        name: "Cluster",
        source: clusterSource,
        animationDuration: 700,
        // Cluster style
        style: getStyle
      } as any);
      this.map3.addLayer(clusterLayer);
      // add 2000 features
      addFeatures(2000);

      var style1 = new Style({
        image: new Circle({
          radius: 5,
          stroke: new Stroke({
            color: "rgba(128,0,0,0.8)",
            width: 2
          }),
          fill: new Fill({
            color: "rgba(128,0,0,0.8)"
          })
        }),
        // Draw a link beetween points (or not)
        stroke: new Stroke({
          color: "#fff",
          width: 1
        })
      });
      // Select interaction to spread cluster out and select features
      var selectCluster = new SelectCluster({
        // Point radius: to calculate distance between the features
        pointRadius: 7,
        animate: true,
        // Feature style when it springs apart
        featureStyle: function () {
          return [style1];
        },
        // selectCluster: false,	// disable cluster selection
        // Style to draw cluster when selected
        style: function (f, res) {
          var cluster = f.get("features");
          if (cluster.length > 1) {
            return getStyle(f, res);
          } else {
            return [
              new Style({
                image: new Circle({
                  stroke: new Stroke({
                    color: "rgba(0,0,192,0.5)",
                    width: 2
                  }),
                  fill: new Fill({ color: "rgba(0,0,192,0.3)" }),
                  radius: 5
                })
              })
            ];
          }
        }
      });
      this.map3.addInteraction(selectCluster);
    }, 50);



  }
  close() {
    setTimeout(() => {
      var chart1 = document.getElementById("chart1") as any;
      var chart2 = document.getElementById("chart2") as any;
      var chart3 = document.getElementById("chart3") as any;
      var chart4 = document.getElementById("chart4") as any;
      var chart6 = document.getElementById("chart12") as any;
      var chart7 = document.getElementById("chart13") as any;

      chart2.classList.remove("chart2-click");
      chart1.classList.remove("chart1-click");
      chart3.classList.remove("chart3-click");
      chart4.classList.remove("chart4-click");
      chart6.classList.remove("chart6-click");
      chart7.classList.remove("chart5-click");
      this.close7 = false;
      this.close6 = false;
      this.close4 = false;
      this.close3 = false;
      this.close2 = false;
      this.close1 = false;

    }, 100);




  }
  getCarTable = async () => {
    var model = {
      iSystemUser: this.gurdService.decrypt(window.localStorage.getItem('ID')!),
      strSession: this.gurdService.decrypt(localStorage.getItem('Session')!)
    } as any;
    model.iMobileDomain = this.iMobileDomain;
    model.tiMobileType = this.tiMobileType;
    const resp = await axios.post(`Report_CarMotionless`, model);
    var resPars = JSON.parse(resp.data);
    if (resPars.iResult == 0) {
      this.notifyService.showError(resPars.strError);
      return;

    }
    if (resPars.ISSessionExpired == true) {
      this.notifyService.showError('لطفا وارد سیستم شوید');
      this.otherService.removeLocalStorage();
      // this.router.navigate(['login']);
      this.router.navigate(['login'], { queryParams: { error: '39' } });

      return;
    }
    let arr = resPars;
    for (let index = 0; index < resPars.length; index++) {

      if (((index + 1) % 3 == 0)) {
        index = 0;
        this.tabelArray.push(arr.splice(index, 3));
        if (resPars.length == 1) {
          this.tabelArray.push(arr.splice(index, 1));
          return
        }
        else if (resPars.length == 2) {
          this.tabelArray.push(arr.splice(index, 2));
          return
        }
      }
    }
  }
  showchart(id: any) {
    if (!this.isDesktop) {
      return;
    }
    var chart1 = document.getElementById("chart1") as any;
    var chart2 = document.getElementById("chart2") as any;
    var chart3 = document.getElementById("chart3") as any;
    var chart4 = document.getElementById("chart4") as any;
    var chart5 = document.getElementById("chart5") as any;
    var chart6 = document.getElementById("chart12") as any;
    var chart7 = document.getElementById("chart13") as any;
    if (id == 1) {
      chart1.classList.add("chart1-click");
      chart2.classList.remove("chart2-click");
      chart3.classList.remove("chart3-click");
      this.close1 = true;

    }
    if (id == 2) {
      chart2.classList.add("chart2-click");
      chart1.classList.remove("chart1-click");
      chart3.classList.remove("chart3-click");
      this.close2 = true;


    }
    if (id == 3) {
      chart3.classList.add("chart3-click");
      chart2.classList.remove("chart2-click");
      chart1.classList.remove("chart1-click");
      this.close3 = true;
    }
    if (id == 4) {
      chart4.classList.add("chart4-click");
      chart3.classList.remove("chart3-click");
      chart2.classList.remove("chart2-click");
      chart1.classList.remove("chart1-click");
      this.close4 = true;
    }
    if (id == 5) {
      chart5.classList.add("chart5-click");
      chart4.classList.remove("chart4-click");
      chart3.classList.remove("chart3-click");
      chart2.classList.remove("chart2-click");
      chart1.classList.remove("chart1-click");
      this.close5 = true;
    }
    if (id == 6) {
      chart6.classList.add("chart6-click");
      chart5.classList.remove("chart5-click");
      chart4.classList.remove("chart4-click");
      chart3.classList.remove("chart3-click");
      chart2.classList.remove("chart2-click");
      chart1.classList.remove("chart1-click");
      this.close6 = true;
    }
    if (id == 7) {
      chart7.classList.add("chart5-click");
      chart6.classList.remove("chart6-click");
      chart5.classList.remove("chart5-click");
      chart4.classList.remove("chart4-click");
      chart3.classList.remove("chart3-click");
      chart2.classList.remove("chart2-click");
      chart1.classList.remove("chart1-click");
      this.close7 = true;
    }


  }
  showModal = async (data: any) => {
    var model = {
      strUnitID: data.Y,
      strSession: this.gurdService.decrypt(localStorage.getItem('Session')!),
      id: this.gurdService.decrypt(window.localStorage.getItem('ID')!)
    }
    const resp = await axios.post(`GetMobileInfo`, model);

    if (resp.data.ISSessionExpired == true) {

      this.otherService.removeLocalStorage();

      // this.router.navigate(['login']);
      this.router.navigate(['login'], { queryParams: { error: '40' } });

      return;

    }

    $('#carModal').modal('show');
    this.modalData = resp.data;
  }
  showData(item: any) {
    var tooltip = $('#map_tooltip');
    tooltip.tooltip({
      html: true,
      animation: true,
      trigger: 'manual',
      placement: 'top',
    });
    tooltip.css({
      left: item.pixel[0] + 'px',
      top: item.pixel[1] - 14 + 'px',
      zindex: 1000,
    });
    if (item.featureLayer) {
      if (item.featureLayer.feature) {
        if (item.featureLayer.feature.values_.features.length == 1) {
          if (item.featureLayer.feature.values_.features[0].values_.data.strFullName) {
            $('#carCluster').modal('show');
            this.clusterModal = item.featureLayer.feature.values_.features[0].values_.data;

          }
        }

        // tooltip
        //   .attr(
        //     'data-bs-original-title',
        //     //item.featureLayer.feature.get('data').html
        //     '<div><h5>hello</h5></div>'
        //   )
        //   .tooltip('show');
        // $("#map-tooltips").click(() => {

        //   this.router.navigate([`/carInfo/${item.featureLayer.feature.get('data').Id}`]);
        //   tooltip.tooltip('hide');

        // });
      }
    } else {
      tooltip.tooltip('hide');
    }
  }
  getDomain = async () => {
    const resp = await axios.post(
      `GetMobileDomain4Report?iSystemUser=${this.gurdService.decrypt(localStorage.getItem("ID")!)}`,
      {}
    );
    this.domain = JSON.parse(resp.data);
    if (this.iMobileDomain) {
      setTimeout(() => {
        $("#domainDashbord").val(Number(this.iMobileDomain));

      }, 100);
    }
    if (this.tiMobileType) {
      setTimeout(() => {
        $("#carGroup").val(Number(this.tiMobileType));

      }, 100);
    }
  }
  reloadCurrentRoute() {
    let currentUrl = `/dashbord`;
    this.router.navigateByUrl('/', { skipLocationChange: true }).then(() => {
      this.router.navigate([currentUrl]);
    });
  }
  guid(Id: any) {
    this.otherService.guid(Id);
  }
  carStatus = async (tiChart: any, strValue: any) => {
    var model = {
      iSystemUser: this.gurdService.decrypt(localStorage.getItem("ID")!),
      strSession: this.gurdService.decrypt(localStorage.getItem('Session')!),
      iMobileDomain: this.iMobileDomain,
      tiMobileType: this.tiMobileType,
      tiChart: tiChart,
      strValue: strValue
    }
    this.otherService.Showspinner();
    const resp = await axios.post(
      `GetMobileListBaseChartStatus`,
      model
    );
    this.otherService.nonespinner();
    $('#CarStatusModal').modal('show');
    this.carStatusData = JSON.parse(resp.data);
  }
  //excel Repotr
  exportexcel(id: any): void {
    /* pass here the table id */
    let element = document.getElementById(`${id}`);
    const ws: XLSX.WorkSheet = XLSX.utils.table_to_sheet(element);

    /* generate workbook and add the worksheet */
    const wb: XLSX.WorkBook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');

    /* save to file */
    XLSX.writeFile(wb, this.fileName);
  }

}
